import {
    setProfile
} from "../util";

import { AuthSetProfileAction } from "../actions/AuthSetProfile";
import { AuthState } from "../state";


export function authSetProfile(state: AuthState, action: AuthSetProfileAction): AuthState {
    setProfile(action.payload.profile);
    return { ...state, ...action.payload };
}